export default __webpack_public_path__ + "static/media/Punto_02_Fortezza_Vecchia_e_Darsena_Vecchia_FRA_Def.d6524c05.aac";